
import Vue from "vue"
import { state, mutations } from "@/plugins/state"

export default Vue.extend({
  name: 'NavigationDrawerSwitch',
  computed: {
    keepMenuExpanded: {
      get(): boolean {
        return state.keepMenuExpanded
      },
      set(value: boolean): void {
        mutations.setKeepMenuExpanded(value)
      }
    }
  },
  methods: {
    toggleMenuPersistence() {
      // If keep menu expanded is true, open the menu automatically
      if (state.keepMenuExpanded) {
        mutations.setDesktopMenuExpanded(true)
      }
    }
  }
})
